import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "taskColumnNameLine" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "taskColumnNameLine" }
const _hoisted_6 = { class: "taskColumnNameLine" }
const _hoisted_7 = { class: "taskColumnDocumentLine" }
const _hoisted_8 = {
  key: 1,
  class: "ws-pre-line"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "d-flex flex-row flex-wrap gap-1 align-items-center" }
const _hoisted_15 = ["title", "onClick", "disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-double-right" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["title", "disabled", "onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-review-protocol" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["title", "disabled", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-review-detail" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["title", "disabled", "onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass('cic-svg overRideReview')
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["title", "disabled", "onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass('cic-svg review')
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["title", "disabled", "onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass('cic-svg upload')
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["title", "disabled", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass('cic-svg re-upload')
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["title", "disabled", "onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-original-upload" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["title", "disabled", "onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-plot-order-confirm" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["title", "disabled", "onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-plot-order-delivery" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["title", "disabled", "onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-delete" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createTextVNode("\n    ")
const _hoisted_49 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode("\n    ")
const _hoisted_51 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!
  const _component_Iframe = _resolveComponent("Iframe")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-grow-1", this.sizeClass])
    }, [
      _createVNode(_component_ParempiGrid, {
        class: "flex-grow-1",
        columns: this.columns,
        items: this.tasks,
        rowPosIncrementor: () => void 0,
        getRowClass: this.getRowClass,
        filterString: _ctx.quickFilter,
        idProperty: "taskId",
        ref: "grid",
        storageKey: "reviewTaskListWidget",
        currentlySortedColumn: "taskStatus",
        disablePersistentSort: "true",
        andFilter: ""
      }, {
        selectionHeader: _withCtx(() => [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            disabled: this.asyncRunning,
            modelValue: this.selectionAll,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectionAll) = $event)),
            onChange: this.selectAllClicked
          }, null, 8, ["disabled", "modelValue", "onChange"])
        ]),
        name: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            (item.taskType === 'SELECT_CELL_CONNECTION_TASK')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('task.list.taskRevision')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$s(item.name)), 1))
          ])
        ]),
        document: _withCtx(({ item }) => [
          (item.taskType == 'PLOT_ORDER_ACCEPTANCE_TASK' || item.taskType == 'REVIEW_CYCLE_PLOT_TASK')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('plot.task.jobNumberLabel', { jobNumber : item.plotOrderJobNumber ?? '' })), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$s(item.documentVersionName?item.documentVersionName:item.documentOrReleaseName)), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$s(item.documentOrReleaseContent)), 1)
              ], 64))
        ]),
        responsible: _withCtx(({ item }) => [
          (_ctx.mode != _ctx.TaskSearchMode.DONE)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item.mainParticipantPerson?.givenName) + " " + _toDisplayString(item.mainParticipantPerson?.surName) + " (" + _toDisplayString(item.mainParticipantOrganisation?.name) + ") ", 1)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('task.list.extendedDeputyLineDONE', {
              mainGivenName: item.mainParticipantPerson?.givenName,
              mainSurName: item.mainParticipantPerson?.surName,
              mainOrganisation: item.mainParticipantOrganisation?.name,
              ownGivenName: item.signerPerson?.givenName,
              ownSurName: item.signerPerson?.surName,
              ownOrganisation: item.signerOrganisation?.name,
          })), 1))
        ]),
        object: _withCtx(({ item }) => [
          _createTextVNode("(" + _toDisplayString(item.objectReleaseCode) + _toDisplayString(item.objectTypeReleaseCode) + ") " + _toDisplayString(item.objectReleaseName), 1)
        ]),
        projectDesignation: _withCtx(({ item }) => [
          _createTextVNode("(" + _toDisplayString(item.projectCode) + ") " + _toDisplayString(item.projectName), 1)
        ]),
        networkDesignation: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.networkName), 1)
        ]),
        taskStatus: _withCtx(({ item }) => [
          (![_ctx.TaskType.ORIGINAL_DOCUMENT_TASK, _ctx.TaskType.PLOT_ORDER_ACCEPTANCE_TASK, _ctx.TaskType.REVIEW_CYCLE_PLOT_TASK, _ctx.TaskType.ORIGINAL_DOCUMENT_TASK_DONE, _ctx.TaskType.PLOT_ORDER_ACCEPTANCE_TASK_DONE, _ctx.TaskType.REVIEW_CYCLE_PLOT_TASK_DONE].includes(item.taskType))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`w-100 h-100 d-flex flex-column align-items-center justify-content-start text-center text-white ${_ctx.getStatusClass(item.taskDelay)}`)
              }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.formatDelay(item.taskDelay)), 1),
                (!_ctx.isLate && _ctx.isInSignatureFolder(item))
                  ? (_openBlock(), _createElementBlock("b", _hoisted_9, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.$t('task.list.inSignatureFolder')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("b", null, [
                  (item.endDate != null)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t('task.list.deadline', { deadline: _ctx.$d(new Date(item.endDate * 1000), { dateStyle: 'short' }) })), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        uploaded: _withCtx(({ item }) => [
          (item.uploadedDate != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$d(new Date(item.uploadedDate * 1000), { dateStyle: 'short' })), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        reviewStatus: _withCtx(({ item }) => [
          (![_ctx.TaskType.ORIGINAL_DOCUMENT_TASK, _ctx.TaskType.PLOT_ORDER_ACCEPTANCE_TASK, _ctx.TaskType.REVIEW_CYCLE_PLOT_TASK, _ctx.TaskType.ORIGINAL_DOCUMENT_TASK_DONE, _ctx.TaskType.PLOT_ORDER_ACCEPTANCE_TASK_DONE, _ctx.TaskType.REVIEW_CYCLE_PLOT_TASK_DONE].includes(item.taskType))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`w-100 h-100 d-flex flex-column align-items-center justify-content-start text-center text-white ${_ctx.getStatusClass(item.reviewCycleDelay)}`)
              }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.formatDelay(item.reviewCycleDelay)), 1),
                (item.documentOrReleaseEndDate != null || item.overallEndDate != null)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_11, [
                      (item.documentOrReleaseEndDate != null)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('task.list.contractualDeadline', { deadline: _ctx.$d(new Date(item.documentOrReleaseEndDate * 1000), { dateStyle: 'short' }) })), 1))
                        : (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('task.list.computedDeadline', { deadline: _ctx.$d(new Date(item.overallEndDate * 1000), { dateStyle: 'short' }) })), 1))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        reviewDate: _withCtx(({ item }) => [
          (item.reviewDate != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$d(new Date(item.reviewDate * 1000), { dateStyle: 'short' })), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        reviewResult: _withCtx(({ item }) => [
          _createElementVNode("span", {
            class: _normalizeClass({ 'text-danger': !!item.finishCellFlag })
          }, [
            _createElementVNode("strong", null, _toDisplayString(`${_ctx.$s(item.realmCode) ?? ''} ${_ctx.$s(item.realmName) ?? ''}`.trim()) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$s(item.resultOptionName)) + " ", 1),
            _createElementVNode("div", null, _toDisplayString(this.getPositionResultPersonText(item)), 1)
          ], 2)
        ]),
        doneDate: _withCtx(({ item }) => [
          (item.doneDate != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$d(new Date(item.doneDate * 1000), { dateStyle: 'short' })), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        doneResult: _withCtx(({ item }) => [
          (_ctx.isReviewTaskDone(item))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({ 'text-danger': !!item.finishCellFlag })
              }, [
                _createElementVNode("strong", null, _toDisplayString(`${_ctx.$s(item.realmCode) ?? ''} ${_ctx.$s(item.realmName) ?? ''}`.trim()) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$s(item.resultOptionName)), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_14, [
            (!_ctx.isBatch && _ctx.isInSignatureFolder(item))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.toSignatureFolder'),
                  onClick: ($event: any) => (_ctx.toSignatureFolder(item)),
                  disabled: this.asyncRunning
                }, _hoisted_17, 8, _hoisted_15))
              : _createCommentVNode("", true),
            (item.mayDoReviewProtocol && [_ctx.TaskType.REVIEW_TASK, _ctx.TaskType.SELECT_CELL_CONNECTION_TASK, _ctx.TaskType.REVIEW_TASK_DONE, _ctx.TaskType.REVIEW_CYCLE_ENTRY_TASK_DONE, _ctx.TaskType.SELECT_CELL_CONNECTION_TASK_DONE].includes(item.taskType))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.reviewProtocol'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.openReviewProtocol(item))
                }, _hoisted_20, 8, _hoisted_18))
              : _createCommentVNode("", true),
            (item.mayDoReviewDetail && [_ctx.TaskType.REVIEW_TASK, _ctx.TaskType.REVIEW_CYCLE_ENTRY_TASK, _ctx.TaskType.SELECT_CELL_CONNECTION_TASK, _ctx.TaskType.REVIEW_TASK_DONE, _ctx.TaskType.REVIEW_CYCLE_ENTRY_TASK_DONE, _ctx.TaskType.SELECT_CELL_CONNECTION_TASK_DONE].includes(item.taskType))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.reviewDetails'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.openReviewDetails(item))
                }, _hoisted_23, 8, _hoisted_21))
              : _createCommentVNode("", true),
            (item.mayDoAssignReview && _ctx.mode === _ctx.TaskSearchMode.LATE && item.taskType === _ctx.TaskType.REVIEW_TASK && item.taskDelay > -1 && item.ownTaskOrgPersonId == null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.overrideReview'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.reviewOverride(item))
                }, _hoisted_26, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (item.mayDoReview && (item.taskType === _ctx.TaskType.REVIEW_TASK || item.taskType === _ctx.TaskType.ATTACHED_REVIEW_TASK) && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.documentReview'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.review(item))
                }, _hoisted_29, 8, _hoisted_27))
              : _createCommentVNode("", true),
            (item.mayDoUpload && item.taskType === _ctx.TaskType.REVIEW_CYCLE_ENTRY_TASK && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.documentUpload'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.upload(item))
                }, _hoisted_32, 8, _hoisted_30))
              : _createCommentVNode("", true),
            (item.mayDoReUpload && item.taskType === _ctx.TaskType.SELECT_CELL_CONNECTION_TASK && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('general.documentUploadRevision'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.reUpload(item))
                }, _hoisted_35, 8, _hoisted_33))
              : _createCommentVNode("", true),
            (item.mayDoUploadOriginal && item.taskType === _ctx.TaskType.ORIGINAL_DOCUMENT_TASK && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 7,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.editOriginalDocumentRequest'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.requestOriginal(item))
                }, _hoisted_38, 8, _hoisted_36))
              : _createCommentVNode("", true),
            (item.mayDoPlotOrderConfirm && item.taskType === _ctx.TaskType.REVIEW_CYCLE_PLOT_TASK && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 8,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.receivePlotOrder'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.processReviewCyclePlotTask(item))
                }, _hoisted_41, 8, _hoisted_39))
              : _createCommentVNode("", true),
            (item.mayDoPlotOrderDelivery && item.taskType === _ctx.TaskType.PLOT_ORDER_ACCEPTANCE_TASK && (!_ctx.isLateTask(item) || (item.ownTaskOrgPersonId != null && item.taskDelay > -1)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 9,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.plotOrderDeliveryConfirmation'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.processPlotOrderAcceptanceTask(item))
                }, _hoisted_44, 8, _hoisted_42))
              : _createCommentVNode("", true),
            (item.mayDoDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 10,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('task.list.deleteTask'),
                  disabled: this.asyncRunning,
                  onClick: ($event: any) => (_ctx.deleteTask(item))
                }, _hoisted_47, 8, _hoisted_45))
              : _createCommentVNode("", true)
          ])
        ]),
        selection: _withCtx(({ item }) => [
          _createVNode(_component_CheckBox, {
            mode: "flex",
            modelValue: item.selected,
            "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
            onChange: this.selectClicked
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
        ]),
        _: 1
      }, 8, ["columns", "items", "rowPosIncrementor", "getRowClass", "filterString"])
    ], 2),
    _createVNode(_component_Dialog, {
      ref: "reviewDetailsDialog",
      maximizable: "true",
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered', 'reviewDialog']
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_49, _toDisplayString(_ctx.$t('general.close')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Iframe, {
          src: this.reviewDetailsSrc,
          class: "reviewDialogIFrame"
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      ref: "reviewProtocolDialog",
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered', 'reviewDialog']
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_51, _toDisplayString(_ctx.$t('general.close')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Iframe, {
          src: this.reviewProtocolSrc,
          class: "reviewDialogIFrame"
        }, {
          default: _withCtx(() => [
            _hoisted_50
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _: 1
    }, 512)
  ], 64))
}